<template>
  <div>
  <!-- Google Tag Manager (noscript) -->
<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PDQ7QC5X"
height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
<!-- End Google Tag Manager (noscript) -->
    
  <v-app v-if="this.$store.getters['user/isLogin']!='wait'">
    <v-app-bar color="#fff" v-if="headHidden">
      <Header @drawer="changeDrawer" />
    </v-app-bar>
    <div class="body_container">
    <v-navigation-drawer v-model="drawer" absolute class="left-sidebar-drawer" v-if="headHidden" color="#fff" width="216" app>
      <LeftBar/>
    </v-navigation-drawer>
    <v-main color="#e5e5e5" app>
      <v-container fluid >
        <section v-if="$store.state.user.adminLogin" class="admin-lk-notice" role="status" aria-label="Вход администратора в личный кабинет">
          <span class="admin-lk-notice__icon" aria-hidden="true"><v-icon size="20" color="#68758a">mdi-account-key-outline</v-icon></span>
          <div class="admin-lk-notice__content">
            <div class="admin-lk-notice__title">Вы в ЛК пользователя {{ $store.state.user.adminLogin.user }}</div>
            <div class="admin-lk-notice__details">
              <span>Администратор: {{ $store.state.user.adminLogin.admin }}</span>
              <span>Вход: {{ $store.state.user.adminLogin.entered_msk }}</span>
              <span>Сессия до {{ $store.state.user.adminLogin.expires_msk }}</span>
            </div>
            <div v-if="adminSessionError" class="admin-lk-notice__error" role="alert">{{ adminSessionError }}</div>
          </div>
          <v-btn class="admin-lk-notice__exit" outlined small :loading="adminSessionClosing" @click="exitAdminLogin">Выйти из ЛК</v-btn>
        </section>
        <router-view v-if="this.$store.getters['user/isLogin'] && !adminBlocked"></router-view>
        <Login v-else />
      </v-container>
    </v-main>
    </div>
    <v-footer v-if="!this.$store.getters['notification/isFooterHide']" fixed color="#fff" height="52" class="custom_footer">
      <Footer :footer="footerHidden"/>
    </v-footer>
  </v-app>
  </div>
</template>

<script>
// test commit 234234234
import Header from './components/TopHeader.vue'
import Login from './views/LoginForm'
import LeftBar from './components/LeftSidebar.vue'
import Footer from './components/BottomFooter.vue'
import { isAdminRoute } from './router'
export default {
  components: {
    Header,
    LeftBar,
    Footer,
    Login
  },
  data(){
    return {
      drawer: true,
      adminLoginTimer: null,
      adminHeartbeatTimer: null,
      adminSessionToken: null,
      adminSessionClosing: false,
      adminSessionError: '',
    }
  },
  
  created(){
    const entry = new URLSearchParams(window.location.hash.slice(1)).get('admin_lk')
    if (/^adminlk_[a-f0-9]{64}$/.test(entry || '')) {
      // A new tab may inherit sessionStorage from the admin tab.
      sessionStorage.clear()
      sessionStorage.token = entry
      window.history.replaceState(null, '', window.location.pathname + window.location.search)
    }
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-PDQ7QC5X')
  },
  
  beforeMount() {
    if (sessionStorage.token)
    {
      this.$http.post("/auth/token",
      {
      token:sessionStorage.token
      },
      (data)=>{
        if (data && data.token && data.user_data)
        {
        this.$store.commit('user/loginUser', data)
        }
        else
        {
        this.$store.commit('user/logoutUser')
        }

      })
    }
    else
    {
      this.$store.commit('user/logoutUser')
    }
  },
  computed: {
    footerHidden: function () {
      return this.$store.getters['user/isLogin']
    },
    headHidden: function () {
      return this.$store.getters['user/isLogin']
    },
    // Не-админ на админской странице (прямая ссылка, обновление страницы): саму страницу не создаём —
    // она слала бы запросы к админскому API — и уводим на главную. Только когда пользователь уже
    // загружен (login === true, а не 'wait'), иначе админа уводило бы при обновлении страницы.
    adminBlocked: function () {
      return this.$store.getters['user/isLogin'] === true &&
        isAdminRoute(this.$route) &&
        !this.$store.getters['user/getUserFields'].is_admin
    }
  },
  watch: {
    adminBlocked: {
      immediate: true,
      handler(blocked) {
        if (blocked) this.$router.replace('/').catch(() => {})
      }
    },
    '$store.state.user.adminLogin'(info) {
      clearTimeout(this.adminLoginTimer)
      clearInterval(this.adminHeartbeatTimer)
      if (info) {
        this.adminSessionToken = sessionStorage.token
        this.adminLoginTimer = setTimeout(this.exitAdminLogin, info.remaining_ms)
        this.adminHeartbeatTimer = setInterval(this.keepAdminSession, 30000)
        this.keepAdminSession()
      } else if (this.adminSessionToken) {
        this.closeAdminSessionRequest(this.adminSessionToken).catch(() => {})
        this.adminSessionToken = null
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.adminLoginTimer)
    clearInterval(this.adminHeartbeatTimer)
  },
  methods: {
    closeAdminSessionRequest(token) {
      const url = new URL('auth/admin-lk/close', this.$http.axios.defaults.baseURL).href
      const controller = new AbortController()
      const timeout = setTimeout(() => controller.abort(), 5000)
      return fetch(url, {
        method: 'POST', keepalive: true, signal: controller.signal,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      }).then(response => {
        if (!response.ok) throw new Error('Не удалось завершить сессию')
      }).finally(() => clearTimeout(timeout))
    },
    async keepAdminSession() {
      if (!this.adminSessionToken || this.adminSessionClosing) return
      try {
        await this.$http.axios.post('/auth/admin-lk/heartbeat', { token: this.adminSessionToken }, { timeout: 5000 })
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.$store.commit('user/logoutUser')
          window.location.replace('/bases')
        }
      }
    },
    async exitAdminLogin() {
      if (this.adminSessionClosing) return
      this.adminSessionClosing = true
      clearInterval(this.adminHeartbeatTimer)
      this.adminSessionError = ''
      try {
        await this.closeAdminSessionRequest(this.adminSessionToken || sessionStorage.token)
        this.adminSessionToken = null
        this.$store.commit('user/logoutUser')
        window.location.replace('/bases')
      } catch (_) {
        this.adminSessionError = 'Сервер недоступен. Повторите выход. Без связи сессия истечёт в течение 2 минут.'
      } finally {
        this.adminSessionClosing = false
      }
    },
    changeDrawer(){
      this.drawer = !this.drawer
    },
  }
};
</script>
<style>
.admin-lk-notice {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin: 16px 24px 0;
  padding: 12px 16px;
  background: #fafbfc;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  color: #2b2d33;
  text-align: left;
}
.admin-lk-notice__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #f0f2f5;
  flex-shrink: 0;
}
.admin-lk-notice__content { flex: 1 1 260px; min-width: 0; text-align: left; }
.admin-lk-notice .admin-lk-notice__title {
  margin: 0;
  padding: 0;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 600;
  text-align: left;
  overflow-wrap: anywhere;
}
.admin-lk-notice__details {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 16px;
  margin-top: 3px;
  color: #68758a;
  font-size: 12px;
  line-height: 1.6;
}
.admin-lk-notice__exit.v-btn {
  height: 34px;
  color: #55575c;
  border-color: #dfe3e8;
  border-radius: 8px;
  background: #fff;
  font-weight: 600;
  text-transform: none;
  letter-spacing: normal;
  flex-shrink: 0;
}
.admin-lk-notice__exit.v-btn:hover { background: #f0f2f5; }
.admin-lk-notice__error { margin-top: 6px; color: #b04444; font-size: 12px; }
@media (max-width: 600px) {
  .admin-lk-notice { margin: 12px 10px 0; padding: 12px; gap: 10px; }
  .admin-lk-notice__content { flex-basis: calc(100% - 42px); }
  .admin-lk-notice__details { flex-direction: column; }
  .admin-lk-notice__exit.v-btn { margin-left: 42px; }
}
.v-list-item:hover{
  background: #f4f4f4;
}
.my-4 ul li button{
  font-style: normal;
font-weight: 500;
font-size: 16px;
line-height: 26px;
color: #2B2D33!important;
box-shadow: none;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper){
  background: #f4f4f4!important;
}
 .my_toolbar > .theme--light.v-tabs > .v-tabs-bar{
    background: none!important;
  }

  .v-application--is-ltr .v-tabs--align-with-title > .v-tabs-bar:not(.v-tabs-bar--show-arrows):not(.v-slide-group--is-overflowing) > .v-slide-group__wrapper > .v-tabs-bar__content > .v-tabs-slider-wrapper + .v-tab{
    margin-left: 0!important;
  }
  .v-tabs{
    border-bottom: 0!important;
  }
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.v-input--selection-controls{
  margin-top: 0!important;
  padding-top: 0!important;
}
/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
.v-input__control .v-input__slot{
  border: none!important;
}
.v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label{
  font-style: normal;
font-weight: 500;
font-size: 15px;
line-height: 120%;
color: #2B2D33;
}
.container{
  padding: 0!important;
}
.v-toolbar__content, .v-toolbar__extension{
  flex-direction: column;
}
.v-dialog__content{
  z-index: 10000!important;
}
.v-sheet.v-app-bar.v-toolbar:not(.v-sheet--outlined){
  z-index: 1000;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.06), 0px 1px 2px rgba(0, 0, 0, 0.1)!important;
}
.body_container{
  position: relative;
  height: 100%;
}
.cancel_btn{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 120%;
  color: #00809C;
  background: none;
  border: none;
  margin-top: 16px;
  cursor: pointer;
  text-transform: none;
}
.btn_save{
  width: 100%;
  padding: 9px;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 110%;
  color: #2B2D33;
  text-transform: none;
  cursor: pointer;
  margin-bottom: 16px;
}
.v-application ul, .v-application ol{
  padding-left: 0;
}
.render{
  padding: 32px;
}
h1{
  font-style: normal;
  font-weight: 800;
  font-size: 28px;
  line-height: 130%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #404247;
}
.top{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.v-input__slot{
  margin-bottom: 0!important;
}
.v-dialog{
  position: relative;
}
.cancel_modal{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 120%;
  color: #00809C;
  cursor: pointer;
}
.close{
  position: absolute;
  z-index: 1000;
  right: 7px;
  top: 7px;
  width: 14px!important;
  cursor: pointer;
}
.textarea{
  padding: 16px 0 0 0!important;
}
.v-text-field{
  padding: 0!important;
  margin: 0!important;
}
.v-text-field input{
  padding: 0!important;
}
.v-tabs-slider-wrapper{
  height: 4px!important;
  border-radius: 4px;
}
.v-tabs{
  border-bottom: 1px solid #D5D5D6;
}
.custom_footer{
  z-index: 1000!important;
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.1)!important;
}
.v-input__slot:after{
  width: 0;
}
.flex{
  display: flex;
}
body{
  background: #f4f4f4;
  margin: 0;
  padding: 0;
}
#app {
  font-family: 'Manrope', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #F7F7F7;
}
@font-face {
  font-family: 'Manrope';
  src: url('./assets/fonts/Manrope/Manrope-Bold.eot');
  src: local('Manrope Bold'), local('Manrope-Bold'),
    url('./assets/fonts/Manrope/Manrope-Bold.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/Manrope/Manrope-Bold.woff2') format('woff2'),
    url('./assets/fonts/Manrope/Manrope-Bold.woff') format('woff'),
    url('./assets/fonts/Manrope/Manrope-Bold.ttf') format('truetype');
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: 'Manrope';
  src: url('./assets/fonts/Manrope/Manrope-Semibold.eot');
  src: local('Manrope Semibold'), local('Manrope-Semibold'),
    url('./assets/fonts/Manrope/Manrope-Semibold.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/Manrope/Manrope-Semibold.woff2') format('woff2'),
    url('./assets/fonts/Manrope/Manrope-Semibold.woff') format('woff'),
    url('./assets/fonts/Manrope/Manrope-Semibold.ttf') format('truetype');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'Manrope';
  src: url('./assets/fonts/Manrope/Manrope-Regular.eot');
  src: local('Manrope Regular'), local('Manrope-Regular'),
    url('./assets/fonts/Manrope/Manrope-Regular.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/Manrope/Manrope-Regular.woff2') format('woff2'),
    url('./assets/fonts/Manrope/Manrope-Regular.woff') format('woff'),
    url('./assets/fonts/Manrope/Manrope-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Manrope';
  src: url('./assets/fonts/Manrope/Manrope-Light.eot');
  src: local('Manrope Light'), local('Manrope-Light'),
    url('./assets/fonts/Manrope/Manrope-Light.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/Manrope/Manrope-Light.woff2') format('woff2'),
    url('./assets/fonts/Manrope/Manrope-Light.woff') format('woff'),
    url('./assets/fonts/Manrope/Manrope-Light.ttf') format('truetype');
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: 'Manrope';
  src: url('./assets/fonts/Manrope/Manrope-Thin.eot');
  src: local('Manrope Thin'), local('Manrope-Thin'),
    url('./assets/fonts/Manrope/Manrope-Thin.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/Manrope/Manrope-Thin.woff2') format('woff2'),
    url('./assets/fonts/Manrope/Manrope-Thin.woff') format('woff'),
    url('./assets/fonts/Manrope/Manrope-Thin.ttf') format('truetype');
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: 'Manrope';
  src: url('./assets/fonts/Manrope/Manrope-Medium.eot');
  src: local('Manrope Medium'), local('Manrope-Medium'),
    url('./assets/fonts/Manrope/Manrope-Medium.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/Manrope/Manrope-Medium.woff2') format('woff2'),
    url('./assets/fonts/Manrope/Manrope-Medium.woff') format('woff'),
    url('./assets/fonts/Manrope/Manrope-Medium.ttf') format('truetype');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'Manrope';
  src: url('./assets/fonts/Manrope/Manrope-ExtraBold.eot');
  src: local('Manrope ExtraBold'), local('Manrope-ExtraBold'),
    url('./assets/fonts/Manrope/Manrope-ExtraBold.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/Manrope/Manrope-ExtraBold.woff2') format('woff2'),
    url('./assets/fonts/Manrope/Manrope-ExtraBold.woff') format('woff'),
    url('./assets/fonts/Manrope/Manrope-ExtraBold.ttf') format('truetype');
  font-weight: 800;
  font-style: normal;
}
.v-text-field > .v-input__control > .v-input__slot{
  border: 1px solid #AAABAD!important;
  box-sizing: border-box!important;
  border-radius: 6px!important;
  background: #FFFFFF!important;
  padding: 11px!important;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 120%;
  color: #808185;
}
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active){
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 120%;
}
.v-expansion-panel-header .v-expansion-panel-header--active{
  background: red;
}
.v-application .primary{
  background-color: #fff!important;
}
.v-list-item .v-list-item__title, .v-list-item .v-list-item__subtitle{
  white-space: inherit!important;
}
.v-tab{
  text-transform: none!important;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot{
  box-shadow: none !important;
}
.input_custom .v-input__control .v-input__slot:after{
  display: none;
}
.input_custom > .v-input__control > .v-input__slot{
  padding: 9px!important;
}
.v-input__icon{
  height: 20px;
}
.v-select__selection--comma{
  margin: 0;
}
.theme--light.v-text-field > .v-input__control > .v-input__slot:before{
  display: none;
}
.v-expansion-panel:not(:first-child)::after{
  display: none;
}
.v-expansion-panel--active:not(:first-child), .v-expansion-panel--active + .v-expansion-panel{
  margin-top: 0!important;
}
.v-expansion-panel-content__wrap{
  padding: 0!important;
}
.v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot{
  min-height: initial !important;
}
.my_input.locked .v-input__control .v-input__slot{
  background: #F4F4F4;
}
.theme--light.v-data-table tbody tr.v-data-table__selected{
  background: #E6F6F8!important;
}
.v-input--is-focused .v-input__slot{
  box-shadow: 0px 0px 0px 1px #4B5EFF;
  border-radius: 4px;
}
.mini_input .v-input__control .v-input__slot{
  text-align: center;
  padding: 7px!important;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 120%;
  color: #2B2D33;
}
.mini_input .v-input__control .v-input__slot input{
  text-align: center;
}
.v-expansion-panel-content__wrap{
  padding: 0 12px 16px 12px!important;
}
.my_expand_panel .v-expansion-panel-header{
  padding: 0;
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  line-height: 120%;
  color: #2B2D33;
}
.mih40 .v-input__control .v-input__slot{
  min-height: 40px;
}
.v-text-field.v-text-field--solo .v-input__control{
  min-height: 40px;
}
.p2 .v-input__control .v-input__slot{
  padding: 2px!important;
}
.p2 .v-input__control .v-input__slot .v-select__slot .v-input__append-inner{
  margin-top: 10px;
}
.v-tabs-items{
  border-radius: 8px;
}
@media (max-width: 960px){
  .v-toolbar__content{
    padding: 0!important;
  }
  .balance.top .text{
    display: none;
  }
  .balance.top{
    margin-right: 30px;
  }
  .account.top .name{
    display: none;
  }
  .account.top .icon:last-child{
    display: none;
  }
  .replenishment.top{
    display: none;
  }
}
@media (min-width: 960px){
  .replenishment.left{
    display: none;
  }
}
@media (min-width: 500px){
  .bottom .exit{
    display: none;
  }
  .bottom .balance .colu{
    display: none;
  }
  .bottom .account{
    display: none;
  }
  .replenishment.left{
    margin-bottom: 50px;
  }
}
@media (max-width: 500px){
  .right .balance{
    display: none;
  }
  .right .account{
    display: none;
  }
  .notification{
    margin-right: 0!important;
  }
  .replenishment.left{
    margin-bottom: 50px;
    margin-left: 0;
    margin-right: 0;
  }
}
@media (max-width: 650px){
  .render{
    padding: 10px;
  }
  .v-tabs:not(.v-tabs--vertical):not(.v-tabs--right) > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev{
    display: none!important;
  }
  .v-slide-group__content{
    justify-content: center;
  }
}
@media (max-width: 400px){
  .render{
    padding: 0;
  }
  .v-application ul{
    padding-left: 10px;
    padding-bottom: 0;
  }
}
.body_container {
  position: relative;
  min-height: calc(100vh - 64px);
  height: auto;
}

.left-sidebar-drawer {
  top: 0 !important;
  bottom: 0 !important;
  height: auto !important;
  max-height: none !important;
}
</style>
